<template>
  <ul v-if="totalPages > 1" class="pagination">
    <li class="page-item md-paging-previous">
      <a v-if="pagesBefore.length > 0" class="page-link" href="" @click="changePage($event, pageNumber - 1)">&lt;</a>
    </li>
    <li v-for="page in pagesBefore" class="page-item md-paging-page inactive">
      <a class="page-link" href="" @click="changePage($event, page)">{{ page }}</a>
    </li>
    <li class="page-item md-paging-page active">
      <a class="page-link" href="" @click="changePage($event)">{{ pageNumber }}</a>
    </li>
    <li v-for="page in pagesAfter" class="page-item md-paging-page inactive">
      <a class="page-link" href="" @click="changePage($event, page)">{{ page }}</a>
    </li>
    <li class="page-item md-paging-next ">
      <a v-if="pagesAfter.length > 0" class="page-link" href="" @click="changePage($event, pageNumber + 1)">&gt;</a>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    totalPages: Number,
    pageNumber: {
      type: Number,
      default: 1
    }
  },
  computed: {
    pagesBefore() {
      let pages = [];
      for (let i = this.pageNumber - 5; i < this.pageNumber; i++) {
        if (i > 0) {
          pages.push(i);
        }
      }
      return pages;
    },
    pagesAfter() {
      let pages = [];
      for (let i = this.pageNumber + 1; i <= this.pageNumber + 5; i++) {
        if (i <= this.totalPages) {
          pages.push(i);
        }
      }
      return pages;
    }
  },
  methods: {
    changePage(e, number) {
      if (e !== undefined) {
        e.preventDefault();
      }
      if (number !== this.pageNumber && number > 0 && number <= this.totalPages) {
        this.$emit('update', number);
      }
    }
  }
}
</script>